module.exports = __webpack_public_path__ + "static/media/credit-card.54114c51.svg";